module.exports = __webpack_public_path__ + "static/media/PM60.1220388a.JPG";